import {
  useStoryblokState,
  getStoryblokApi,
  StoryblokComponent,
} from "@storyblok/react";
import BackgroundGraphic from "../../components/BackgroundGraphic";
import OrderOfMeritPageTabs from "../../components/OrderOfMeritPageTabs/OrderOfMeritPageTabs";

export default function OrderOfMeritHomePage({ story, tabs }: any) {
  story = useStoryblokState(story);

  return (
    <>
      <BackgroundGraphic align="right" />
      <OrderOfMeritPageTabs tabs={tabs}>
        <StoryblokComponent key={story._uid} blok={story.content} />
      </OrderOfMeritPageTabs>
    </>
  );
}

export async function getStaticProps() {
  const sbParams = {
    version: process.env.VERCEL_ENV === "production" ? "published" : "draft",
    resolve_links: "url",
  };

  const storyblokApi = getStoryblokApi();
  const { data } = await storyblokApi.get(
    `cdn/stories/order-of-merit`,
    sbParams
  );

  const { data: oomStoriesData } = await storyblokApi.get(`cdn/stories/`, {
    ...sbParams,
    starts_with: "order-of-merit",
  });

  const tabs = oomStoriesData?.stories?.map((story: any) => ({
    value: story?.name,
    label: story?.name,
    slug: story?.slug,
  }));

  return {
    props: {
      story: data ? data.story : false,
      key: data ? data.story.id : false,
      tabs,
    },
    revalidate: 10,
  };
}
